export default "__VITE_ASSET__DLPB3Y9k__"